import React from "react";
import ProfileStore from "../Profile/ProfileStore";
import Moment from 'moment';

export default class EventExpired extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Profile: ProfileStore.getState()
        }
    }

    getExpiredTextMessage() {
        let expireDate = Moment();
        if (this.props.selectedEvent.expireDate)
            expireDate = Moment(this.props.selectedEvent.expireDate)

        if (this.props.selectedEvent.expireInfo)
            expireDate = Moment(this.props.selectedEvent.expireInfo.expireDate)

        return this.props.resources['PWS.Events.PartyExpiredTextHtml']
            .replace(/{ExpireDate}/gi, expireDate.format('ll'))
            .replace(/{Contact}/gi, this.state.Profile.name);
    }

    back() {
        if (paramSource == "email") {
            window.location = window.jenkon.consultantRoot;
            return;
        }
        if (paramSource == "shopify") {
            history.back();
            return;
        }

        eventCode = '';
        this.props.backToList();
    }

    renderBackButton() {
        return (
            <div id="publicPartiesList" className="section-wrapper clearfix">
                <div className="sectionButtons" style={{ textAlign: 'center', margin: '12px 0' }}>
                    <button className="bookPartyBtn" onClick={this.back.bind(this)}>
                        {this.props.resources['SiteMap:PWSEvents.Back.Text']}
                    </button>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="site-container icon_button_content animate-in" aria-live="assertive">
                <div className="blurb text-center">
                    <div className="title">{this.props.resources['PWS.Events.PartyExpiredTitle']}</div>
                    <br />
                    <div className="description" dangerouslySetInnerHTML={{ __html: this.getExpiredTextMessage() }}></div>
                </div>

                {this.props.backToList && this.renderBackButton()}
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/Events/EventExpired.js